import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoPersonalCare = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>PersonalCare</title>
    <path
      d="m9.23 17.571-3.482 4.037a1.375 1.375 0 0 0-.03 1.76l2.223 2.766c.406.505 1.11.658 1.69.367l1.98-.995c.127-.064.264-.108.405-.13l7.386-1.15c.377-.059.712-.271.926-.587l4.538-6.687c.456-.67.163-1.521-.625-1.333-2.544.608-6.418 4.033-7.317 4.852a1.266 1.266 0 0 1-.438.266c-.587.204-2.057.651-2.518.19a8.234 8.234 0 0 1-.152-.156c-.424-.445-.36-1.11.063-1.555l2.47-2.594.042-.043c.16-.165 1.165-1.253.342-2.077-.758-.758-1.646-.293-1.896-.135-.047.03-.09.058-.138.086-.5.286-3.565 2.042-5.024 2.774-.17.085-.32.2-.444.344Z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.346 16.907c-1.297-1.587-2.888-3.933-2.981-6.16C6.24 7.774 8.8 5 11.805 5c1.165 0 2.093.276 3.13 1.053.352.264.95.901.95.901s.54-.596.95-.9C17.874 5.278 18.798 5 19.964 5c3.004 0 5.563 2.774 5.44 5.747-.064 1.54-.894 4.117-1.357 5.138"
      stroke="currentColor"
      strokeWidth={2}
    />
  </svg>
);
export default SvgIcoPersonalCare;
